import React from "react";
import "../styles/AppLoader.css";

const AppLoader = () => {
  return (
    <div className="app-loader-container">
      <div className="app-loader-content">
        {/* Logo */}
        <div className="app-loader-logo">
          <img 
            src="/images/Logo.png" 
            alt="Company Logo" 
            className="logo-img"
          />
        </div>
        
        {/* Loading animation */}
        <div className="app-loader-spinner">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            enableBackground="new 0 0 0 0"
            xmlSpace="preserve"
            width="40px"
            height="40px"
          >
            <path
              fill="#0053ed"
              d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
            >
              <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="rotate"
                dur="1s"
                from="0 50 50"
                to="360 50 50"
                repeatCount="indefinite"
              />
            </path>
          </svg>
        </div>
        
        {/* Loading text */}
        <div className="app-loader-text">Loading...</div>
      </div>
    </div>
  );
};

export default AppLoader;